import http from "../http-common";

class MerchantConfigService {
  /**
   * Lấy cấu hình merchant hiện tại
   */
  getMerchantConfig() {
   return http.get(`/online-payment/bank-hub/merchant-config`)
  }

  /**
   * Cập nhật cấu hình merchant
   */
  updateMerchantConfig(data) {
    return http.post(`/online-payment/bank-hub/merchant-config/update`, data)
  }

  /**
   * Upload logo merchant
   */
  uploadLogo(file) {
    const formData = new FormData();
    formData.append('logo', file); // SePay API expects 'logo' field name

    return http.post(`/online-payment/bank-hub/merchant-config/logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  /**
   * Lấy cấu hình webhook hiện tại
   */
  getWebhook() {
    return http.get(`/online-payment/bank-hub/webhook`);
  }

  /**
   * Tạo hoặc cập nhật webhook (upsert)
   */
  updateWebhook(data) {
    return http.post(`/online-payment/bank-hub/webhook/update`, data);
  }

  /**
   * Tạo Link Token để liên kết/hủy liên kết tài khoản ngân hàng
   */
  createLinkToken(data) {
    return http.post(`/online-payment/bank-hub/link-token/link`, data);
  }

    /**
     * Tạo Link Token để liên kết/hủy liên kết tài khoản ngân hàng
     */
    createLinkTokenUnlink(data) {
        return http.post(`/online-payment/bank-hub/link-token/unlink`, data);
    }
}

export default new MerchantConfigService();

